import { render, staticRenderFns } from "./MeterialEdit.vue?vue&type=template&id=c6736d92&scoped=true"
import script from "./MeterialEdit.vue?vue&type=script&lang=js"
export * from "./MeterialEdit.vue?vue&type=script&lang=js"
import style0 from "./MeterialEdit.vue?vue&type=style&index=0&id=c6736d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6736d92",
  null
  
)

export default component.exports